import React, {useMemo, useRef, useState} from "react";
import {useMount} from "react-use";
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Alert, Badge, Input, Statistic} from "antd";
import SpinLoader from "../../../components/SpinLoader";
import {useProjectScope} from "./ProjectScopeProvider";

const ProjectDeliverableForm = ({onChange, ...props}) => {


    const {isDisabled, scope} = useProjectScope();
    const nameRef = useRef(null);
    const formRef = useRef(null);
    const [editable, setEditable] = useState(false);
    const [desiredLabel, desiredColor] = useMemo(() => {
        let color;
        let label;
        switch (props.record.is_desired) {
            case true:
                color = TB.config('color.success-dark');
                label = 'Yes';
                break;
            case false:
                color = TB.config('color.danger-dark');
                label = 'No';
                break;
            case null:
                color = '#b7b7b7';
                label = 'Unsure';
                break;
        }

        if (props.record.is_custom) {
            color = TB.config('color.warning-dark');
            label = 'Custom';
        }
        return [label, color]
    }, [props.record?.is_desired]);

    useMount(() => {
        setTimeout(() => {
            setEditable(true)
        }, 50)
    })
    return (
        <SpinLoader isLoading={isDisabled}>
            <Form
                ref={formRef}
                model={scope}
                onChange={(model) => {
                    console.log('ProjectDeliverableFormChange', model)
                    return onChange(model);
                }}
                onSubmit={null}
                submitButton={false}
                minimal
                background="transparent"
                fields={[]}
                isDisabled={!editable || isDisabled}>
                <div className="flex flex-col items-stretch">

                    <div className="sm:flex flex-row gap-4">

                        <div className="basis-1/2">
                            <FormInputComponent
                                fieldName={`${props.recordKey}.name`}
                                value={props.record?.name || ''}
                                disabled={!editable || isDisabled}
                                required={false}
                                label="Deliverable Name:"
                                type="antd-input">

                                <Input ref={nameRef} defaultValue={props.record?.name || ''}/>

                            </FormInputComponent>
                        </div>

                        <div className="basis-1/2 flex gap-6 justify-center">
                            <div className="flex items-center">
                                <Statistic title="Estimated Hours" value={`${props.record.total_hours} hrs`}/>
                            </div>
                            <div className="flex items-center">
                                <Statistic title="Estimated Cost"
                                           value={TB.formatCurrency(props.record.estimated_cost)}/>
                            </div>
                        </div>

                    </div>

                    <div className="mt-4 mb-6">
                        <Alert
                            message="Client Feedback"
                            className="project-scope-form-alert"
                            closable={true}
                            description={(
                                <div className="flex flex-col gap-4">
                                    <div className="flex flex-row items-center gap-2">
                                        <p className="text-xs font-medium">
                                            Desired By Client:
                                        </p>
                                        <Badge count={desiredLabel} showZero color={desiredColor}/>
                                    </div>
                                    <div className="w-full flex flex-col items-start relative">
                                        <div className="flex flex-row items-center gap-2">
                                            <p className="text-xs font-medium">
                                                Client Provided Notes:
                                            </p>
                                            <div className="relative">
                                                <p className="text-xs line-clamp-3 overflow-ellipsis">{props.record.client_comments || (
                                                    <i>No Addition Notes Provided</i>)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            type="info"
                        />

                    </div>


                    <FormInputComponent
                        fieldName={`${props.recordKey}.assumptions`}
                        value={props.record?.assumptions || ''}
                        disabled={!editable || isDisabled}
                        required={false}
                        label="Assumptions:"
                        type="editor"
                        tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                    />
                    <FormInputComponent
                        fieldName={`${props.recordKey}.notes_to_talent`}
                        value={props.record?.notes_to_talent || ''}
                        disabled={!editable || isDisabled}
                        required={false}
                        label="Notes To Talent:"
                        type="editor"
                        tools={['bold', 'italic', 'underline', 'link', 'ol', 'ul']}
                    />
                </div>
            </Form>
        </SpinLoader>
    )
}
export default ProjectDeliverableForm